import React from "react";
import { Platform, Text, StyleSheet, View, FlatList } from "react-native";
import _ from "lodash";

export default class WrappedFlatList extends React.Component {
    constructor(props) {
        super(props);
        this._offset = 0;
    }

    componentDidMount() {
        this._timer = setTimeout(this._checkScrollPos, 200);
    }

    componentWillUnmount() {
        if (this._timer) {
            clearTimeout(this._timer);
            delete this._timer;
        }
    }

    _checkScrollPos = () => {
        // FIX BUG: https://github.com/ptomasroos/react-native-scrollable-tab-view/issues/1171
        if (this._flatList && (0 === this._offset)) {
            if (Platform.OS === 'ios') {
                this._flatList.scrollToOffset({offset: 1, animated: false});
            }
        }
    };

    _setupFlatList = (r) => {
        if (this._flatList !== r) {
            this._flatList = r;
            this._checkScrollPos();
        }
    };

    _onScroll = (e) => {
        this._offset = e.nativeEvent.contentOffset.y;
        this._checkScrollPos();

        if (this.props.onScroll) {
            this.props.onScroll(e);
        }
    };

    render() {
        let { onScroll, ...props } = this.props;
        return (<FlatList ref={this._setupFlatList}
                          {...props} onScroll={this._onScroll}/>);
    }
}
